import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchMonthlyRevenue } from "../../services/monthrevenue.services";

// Async Thunk for fetching revenue data
export const fetchMonthlyRevenueReport = createAsyncThunk(
  "monthlyRevenue/fetchReport",
  async (year, { rejectWithValue }) => {
    try {
      const data = await fetchMonthlyRevenue(year);
      return data.data; // Return the "data" field from the API response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Redux Slice
const monthlyRevenueSlice = createSlice({
  name: "monthlyRevenue",
  initialState: {
    data: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlyRevenueReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMonthlyRevenueReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload; // Store the revenue data
      })
      .addCase(fetchMonthlyRevenueReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default monthlyRevenueSlice.reducer;
